import type { CityConfig } from "../city-template/types";

export const bloomingtonILConfig: CityConfig = {
  city: "Bloomington",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "bloomington-il",
  route: "/cities/bloomington-il",
  title: "Emergency Passport Bloomington, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Bloomington, Illinois — as fast as 24 hours. Fast passport renewal for State Farm corporate travelers, Illinois Wesleyan faculty, and all McLean County residents. A+ BBB rated registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Bloomington, IL",
  heroSubtitle: "State Farm corporate trip to Zurich with 6 days notice? Illinois Wesleyan study abroad departure and your passport's missing? Bloomington-Normal family vacation to Greece next week? We help Bloomington residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving McLean County and Central Illinois.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Bloomington%20Illinois%20scenic%20cityscape%20featuring%20historic%20downtown%20McLean%20County%20Courthouse%20with%20its%20iconic%20dome%2C%20tree%20lined%20streets%20of%20a%20charming%20Midwestern%20city%2C%20Illinois%20Wesleyan%20University%20campus%20with%20collegiate%20Gothic%20architecture%2C%20State%20Farm%20corporate%20headquarters%20skyline%2C%20Route%2066%20heritage%20through%20central%20Illinois%2C%20golden%20hour%20warm%20light%20over%20the%20prairie%20landscape%2C%20professional%20urban%20photography&width=1800&height=700&seq=bloomington-il-hero-001&orientation=landscape",
  heroImageAlt: "Bloomington Illinois with McLean County Courthouse and Illinois Wesleyan campus at golden hour",
  geoPosition: "40.4842;-88.9937",
  geoPlacename: "Bloomington, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 2 hours 15 minutes northeast of Bloomington via I-55",
  },
  nearbyCitiesZips: [
    { name: "Bloomington", zips: "61701, 61702, 61704, 61705" },
    { name: "Normal", zips: "61761" },
    { name: "Hudson", zips: "61748" },
    { name: "Towanda", zips: "61776" },
    { name: "Lexington", zips: "61753" },
    { name: "Le Roy", zips: "61752" },
    { name: "Heyworth", zips: "61745" },
    { name: "Downs", zips: "61736" },
    { name: "Chenoa", zips: "61726" },
    { name: "El Paso", zips: "61738" },
    { name: "Lincoln", zips: "62656" },
    { name: "Pontiac", zips: "61764" },
    { name: "Clinton", zips: "61727" },
    { name: "Morton", zips: "61550" },
    { name: "Peoria", zips: "61602, 61603, 61604, 61605, 61606, 61614, 61615" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — 2+ hours away but you skip the trip" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-2-line", title: "Corporate Travel Hub", desc: "Serving State Farm, Country Financial, and Rivian corporate travelers in Central Illinois" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from any UPS or FedEx in Bloomington-Normal — no Chicago drive required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Peoria, IL", route: "/cities/peoria" },
    { name: "Emergency passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Urgent passport services in Champaign, IL", route: "/cities/champaign" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Bloomington, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (2 hours 15 minutes northeast via I-55) — without you making the trip. Bloomington-Normal residents can ship from any UPS or FedEx in McLean County.",
  fpcOfficeDistance: "Serving Bloomington, Normal, Hudson, Towanda, Lexington, Le Roy, Heyworth, Downs, Chenoa, El Paso, Lincoln, Pontiac, Clinton, Morton, Peoria, and all of McLean County and Central Illinois",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Bloomington-Normal and Central Illinois. From the State Farm corporate campus and Illinois Wesleyan University to Illinois State University in Normal, from the historic downtown around the McLean County Courthouse to the I-55 business corridor, and the communities of Hudson, Le Roy, and Downs — we serve all of McLean County and surrounding areas.",
  nearbyCitiesIntro: "We serve Bloomington-Normal and all nearby communities including Hudson, Towanda, Lexington, Le Roy, Heyworth, Downs, Chenoa, El Paso, Lincoln, Pontiac, Clinton, Morton, and Peoria. We also serve all McLean County and Central Illinois communities.",
  howItWorksIntro: "Most Bloomington travelers complete everything online and ship documents overnight. No need to drive 2 hours 15 minutes to Chicago — our couriers handle the Chicago Passport Agency trip for you.",
  mistakesIntro: "Bloomington-Normal is the corporate heart of Central Illinois with State Farm, Country Financial, and a growing tech sector sending employees worldwide. Here are the most common passport mistakes we see from McLean County travelers.",
  testimonialsIntro: "Bloomington-Normal travelers — from State Farm executives and insurance professionals to Illinois Wesleyan and ISU faculty — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Bloomington, IL? Here are the most common ones we hear from Central Illinois travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No 4.5-hour round trip to Chicago required", "Perfect for corporate travel and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 2+ hours to downtown Chicago", "Time off work, tolls, parking, navigation stress"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Bloomington travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Chicago Passport Agency — 2+ hours away but you never make the trip.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "Perfect for State Farm corporate travel emergencies"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Bloomington adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Bloomington address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Bloomington residents — including first-time travelers, new citizens, and young professionals.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Bloomington residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Bloomington-Normal families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Bloomington and McLean County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Bloomington IL", description: "Urgent passport processing for Bloomington Illinois travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Bloomington IL", description: "Fast passport renewal for Bloomington Illinois residents and State Farm corporate travelers." },
    { name: "First-Time Passport Bloomington IL", description: "New passport application services for Bloomington Illinois residents." },
    { name: "Child Passport Bloomington IL", description: "Minor passport services for Bloomington Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Mark S.",
      location: "Bloomington, IL",
      rating: 5,
      text: "State Farm sent me to their Zurich office for a month with 10 days notice — and my passport was expired. Fast Passport Center got my renewal in 3 days. I shipped from the UPS on Veterans Parkway. Never had to leave Bloomington. Unbelievable service for Central Illinois business travelers.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer W.",
      location: "Normal, IL",
      rating: 5,
      text: "My daughter's ISU study abroad program to Spain needed her passport in 2 weeks. Fast Passport Center walked us through the first-time passport process and it arrived in 4 days. The dedicated agent was phenomenal — understood exactly what we needed.",
      service: "First-Time Passport",
    },
    {
      name: "Tom R.",
      location: "Bloomington, IL",
      rating: 5,
      text: "Family cruise from Barcelona leaving in 7 days and my wife's passport had water damage from our basement flood. Fast Passport Center replaced it in 32 hours. We made our flight out of Chicago. Saved our 25th anniversary trip.",
      service: "Damaged Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "blm-1",
      name: "Bloomington Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1211 Towanda Ave",
      city: "Bloomington",
      state: "IL",
      zip: "61701",
      phone: "(309) 662-0523",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bloomington, near Veterans Parkway",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Bloomington acceptance facility. Convenient to east Bloomington and Veterans Parkway corridor. Appointments strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "blm-2",
      name: "Normal Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 W North St",
      city: "Normal",
      state: "IL",
      zip: "61761",
      phone: "(309) 452-3180",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Normal, near ISU campus and Uptown Normal",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for ISU students and Normal residents. Near Illinois State University campus.",
      icon: "ri-mail-line",
    },
    {
      id: "blm-3",
      name: "McLean County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "104 W Front St, Room 404",
      city: "Bloomington",
      state: "IL",
      zip: "61701",
      phone: "(309) 888-5340",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Bloomington, McLean County Law and Justice Center",
      website: "https://www.mcleancountyil.gov/",
      websiteLabel: "McLean County Circuit Clerk",
      notes: "County acceptance facility — good alternative to post office. Located in historic downtown Bloomington. Call ahead.",
      icon: "ri-government-line",
    },
    {
      id: "blm-4",
      name: "Lincoln Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "127 S Kickapoo St",
      city: "Lincoln",
      state: "IL",
      zip: "62656",
      phone: "(217) 732-3701",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lincoln, approximately 35 miles south of Bloomington via I-55",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Logan County. Convenient for southern McLean County and Logan County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "blm-5",
      name: "Pontiac Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 W Washington St",
      city: "Pontiac",
      state: "IL",
      zip: "61764",
      phone: "(815) 844-3401",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Pontiac, approximately 40 miles northeast of Bloomington via I-55",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Livingston County. Near historic Route 66 museum. Full passport acceptance services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2+ hour drive to Chicago", fpc: "No — ship from Bloomington" },
    { feature: "Time & Cost", agency: "4.5 hour round trip plus parking", fpc: "Ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Corporate Travel Last-Minute Discovery",
      description: "State Farm and Country Financial employees in Bloomington frequently get deployed internationally on short notice. Many discover expired passports just days before. The 2+ hour drive to Chicago makes a last-minute agency visit nearly impossible on a workday.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Passport Validity Rule",
      description: "Many countries require your passport to be valid at least 6 months beyond your return date. Bloomington corporate travelers for short European trips often assume 3 months is enough — it's not. Always check entry requirements.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Specs",
      description: "Local photo services in Bloomington-Normal may not follow strict 2x2 inch standards. Head size, shadow, or background issues cause rejection. Use dedicated passport photo services that guarantee compliance.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete Application Forms",
      description: "Missing middle names, wrong SSN, or incorrect form type are common at Bloomington-Normal acceptance facilities. Double-check every field — errors mean starting over and missing your travel window.",
    },
    {
      icon: "ri-road-map-line",
      title: "Unnecessary Drive to Chicago",
      description: "Bloomington is 2+ hours each way to the Chicago Passport Agency — that's essentially a full day off work. Our courier service makes the trip for you. Don't burn a vacation day for passport paperwork.",
    },
    {
      icon: "ri-graduation-cap-line",
      title: "Study Abroad Passport Delays",
      description: "ISU and IWU students planning study abroad often wait until the last minute. Passport processing takes weeks through standard channels. Start at least 2 months before your study abroad departure date.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Bloomington-Normal." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx on Veterans Parkway or Main Street." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with corporate travel, academic, and family documentation." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — 2+ hours away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Bloomington address — trackable and secure." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Bloomington, IL?", a: "Fast Passport Center offers emergency passport processing in Bloomington, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (2 hours 15 minutes northeast via I-55) — without you making the trip." },
    { q: "Does Bloomington-Normal have a passport agency?", a: "No — Bloomington-Normal does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 2 hours 15 minutes northeast via I-55. Fast Passport Center's courier service means Central Illinois residents never need to make the drive." },
    { q: "Can you help State Farm employees with corporate travel passports?", a: "Absolutely. Fast Passport Center serves State Farm, Country Financial, Rivian, and all corporate travelers in Bloomington-Normal. Our service is ideal for business professionals who can't take a full day to drive to Chicago. We handle international corporate travel needs with priority processing." },
    { q: "What airport do Bloomington travelers use for international flights?", a: "Central Illinois Regional Airport (BMI) offers regional connections. For international flights, most Bloomington travelers use Chicago O'Hare (ORD) — approximately 2 hours 15 minutes northeast via I-55. Some also use St. Louis Lambert (STL) — approximately 2 hours 15 minutes south." },
    { q: "Do you serve Normal, Hudson, and other McLean County communities?", a: "Yes — Fast Passport Center serves all of Bloomington-Normal and McLean County including Hudson, Towanda, Lexington, Le Roy, Heyworth, Downs, Chenoa, El Paso, Lincoln, Pontiac, and Clinton. Our service works identically across the region." },
    { q: "Can I get a child's passport expedited in Bloomington?", a: "Yes. Fast Passport Center expedites child passports in Bloomington-Normal for minors under 16. Both parents must appear or submit notarized consent along with the child's birth certificate and both parents' IDs. We walk McLean County families through the process." },
    { q: "Where can I get passport photos in Bloomington?", a: "Walgreens on Veterans Parkway, CVS on Main Street, and the UPS Store on Towanda Avenue all offer passport photos. ISU and IWU campus services may also provide them during academic sessions. Photos must be 2x2 inches on a white background." },
    { q: "How much does an expedited passport cost in Bloomington?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for renewal. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your departure timeline." },
  ],
  photoLocations: [
    { name: "Walgreens — Bloomington", address: "2404 S Veterans Pkwy, Bloomington, IL 61704", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Bloomington", address: "2103 N Veterans Pkwy, Bloomington, IL 61704", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "CVS — Normal", address: "1700 W College Ave, Normal, IL 61761", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart Supercenter — Normal", address: "300 Greenbriar Dr, Normal, IL 61761", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Bloomington", address: "1510 W Market St, Bloomington, IL 61701", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Near downtown Bloomington. Online reservations recommended.", featured: true },
    { name: "Illinois SOS — Pontiac", address: "507 W Reynolds St, Pontiac, IL 61764", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Livingston County and eastern McLean County. REAL ID processing available.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for McLean County birth and death certificates" },
    { label: "Marriage Licenses (McLean County Clerk)", url: "https://www.mcleancountyil.gov/27/County-Clerk", desc: "McLean County Clerk — marriage license applications and certified copies for Bloomington-Normal" },
    { label: "Divorce Decrees (McLean County Circuit Clerk)", url: "https://www.mcleancountyil.gov/141/Circuit-Clerk", desc: "McLean County Circuit Clerk — divorce decree records for Bloomington and McLean County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "BMI",
      name: "Central Illinois Regional Airport",
      distance: "Approximately 5 miles east of downtown Bloomington",
      address: "3201 Cira Dr, Bloomington, IL 61704",
      note: "Regional airport with daily flights to major hubs via American, Delta, and Allegiant. About 10 minutes from downtown Bloomington. Good for domestic connections.",
      flightUrl: "https://www.cira.com/",
      flightLabel: "BMI Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 2 hours 15 minutes northeast via I-55",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Primary international airport for Bloomington-Normal. One of the world's busiest airports with direct global flights. United and American Airlines hub.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
    {
      code: "PIA",
      name: "General Wayne A. Downing Peoria International Airport",
      distance: "Approximately 45 minutes west via I-74",
      address: "6100 W Everett M Dirksen Pkwy, Peoria, IL 61607",
      note: "Regional airport with Allegiant and American Eagle flights. About 45 minutes from Bloomington-Normal. Good for domestic connections and regional flights.",
      flightUrl: "https://www.flypia.com/",
      flightLabel: "PIA Flight Info",
      featured: false,
    },
  ],
};